<div class="bg-white rounded-lg border border-gray-200 p-8">
  <h1 class="text-2xl font-bold text-[#3abfad] mb-1">
    2. Validación de identidad <span class="text-gray-600 font-normal">(1 de 2)</span>
  </h1>
  <p class="text-gray-600 mb-6">Responde las siguientes preguntas para completar la evaluación.</p>

  <form class="space-y-6">
    <!-- Ocupación -->
    <div class="space-y-2">
      <label for="ocupacion" class="block text-sm font-medium">
        ¿Cuál es tu ocupación?<span class="text-red-500">*</span>
      </label>
      <select id="ocupacion" class="w-full">
        <option value="" disabled selected>Selecciona tu ocupación</option>
        <option *ngFor="let ocupacion of ocupaciones" [value]="ocupacion.value">{{ ocupacion.label }}</option>
      </select>
    </div>

    <!-- Ingreso mensual -->
    <div class="space-y-2">
      <label for="ingreso" class="block text-sm font-medium">
        ¿Cuál es tu ingreso mensual?<span class="text-red-500">*</span>
      </label>
      <div class="relative">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
        <input id="ingreso" placeholder="1.000.000" class="w-full pl-8" value="1.000.000" />
      </div>
    </div>

    <!-- Personas en domicilio -->
    <div class="space-y-2">
      <label for="personas" class="block text-sm font-medium">
        ¿Cuántas personas viven en tu domicilio?<span class="text-red-500">*</span>
      </label>
      <select id="personas" class="w-full">
        <option value="" disabled selected>Selecciona cantidad</option>
        <option *ngFor="let persona of personasDomicilio" [value]="persona.value">{{ persona.label }}</option>
      </select>
    </div>
  </form>
</div> 